module.exports = __webpack_public_path__ + "media/venue/meetups@1x-7851acda.png";